import {
    IntegratedFiltering,
    IntegratedPaging,
    IntegratedSorting,
    PagingState,
    SortingState,
    TableColumnResizing,
} from '@devexpress/dx-react-grid';
import {
    DragDropProvider,
    Grid,
    PagingPanel,
    Table,
    TableColumnReordering,
    TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { LinearProgress } from 'material-ui';
import CheckIcon from 'material-ui-icons/Check';

import Paper from 'material-ui/Paper';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import { reduxForm } from 'redux-form';
import getReportTypes from '../../../actions/getReportTypes';
import addEditCustomer from '../../../actions/addEditCustomer';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import getCustomers from '../../../actions/getCustomers';
import searchAllPages from '../../../actions/searchAllPages';
import compareCaseInsensitive from '../../../helpers/CompareCaseInsensitive';
import { ProductMap } from '../../../helpers/ProductMap';
import SimpleMenu from '../../../helpers/SimpleMenu';
import SkeletonTableRows from '../../../helpers/SkeletonTableRows';
import TableFilters from '../../../helpers/TableFilters';
import { cacheTableOptions, getTableOptions, filterCustomersByProduct, isUserATSysAdmin } from '../../../helpers/Util';
import Layout from '../../Layout';
import { isSysAdmin } from '../../../helpers/security/roles';
import OverflowTip from '../../../helpers/OverflowTip';
import {
    Clear as InactiveIcon,
    HighlightOff as HighlightOffIcon,
    Block as SuspendedIcon
} from '@material-ui/icons';



const componentKey = 'customer-list';
const paperStyle = {
    width: '85%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '4vh'
};

class CustomerList extends Component {
    constructor(props) {
        super(props);

        const columns = [
            { name: 'isActive', title: 'Active' },
            { name: 'name', title: 'Customer' },
            { name: 'autotecId', title: 'AutoTec ID' },
            { name: 'contactName', title: 'Contact Name' },
            { name: 'email', title: 'Email Address' },
            { name: 'city', title: 'City' },
            { name: 'state', title: 'State' },
            { name: 'customerGroupName', title: 'Customer Group' },
            { name: 'menu', title: ' ' },
        ];
        const skeletonRows = SkeletonTableRows({ columns: columns, rowKey: 'customerId' });

        this.state = {
            addLink: '/add-edit-customer',
            anchorEl: null,
            columns: columns,
            columnOrder: ['name', 'autotecId', 'contactName', 'email', 'city', 'state', 'customerGroupName', 'menu'],
            columnWidths: [
                { columnName: 'isActive', width: 80 },
                { columnName: 'name', width: 145 },
                { columnName: 'autotecId', width: 90 },
                { columnName: 'contactName', width: 120 },
                { columnName: 'email', width: 150 },
                { columnName: 'city', width: 120 },
                { columnName: 'state', width: 70 },
                { columnName: 'customerGroupName', width: 160 },
                { columnName: 'menu', width: 100 },
            ],
            currentPage: 0,
            allItems: [],
            filterByOptions: [
                { name: 'all', label: 'All' },
                { name: 'active', label: 'Active' },
                { name: 'inactive', label: 'Inactive' },
                { name: 'suspended', label: 'Suspended' },
            ],
            initialValues: {},
            loading: false,
            pageSize: 10,
            pageSizes: [5, 10, 0],
            rows: skeletonRows,
            searchByOptions: [
                { name: 'name', label: 'Customer' },
                { name: 'autotecId', label: 'AutoTec ID' },
                { name: 'contactName', label: 'Contact Name' },
                { name: 'email', label: 'Email Address' },
                { name: 'city', label: 'Physical City' },
                { name: 'state', label: 'Physical State' },
                { name: 'customerGroupName', label: 'Customer Group' }
            ],
            sorting: [{ columnName: 'name', direction: 'asc' }],
            tableColumnExtensions: [],
            title: 'Customers',
            allCustomers: [],
            productFilterOptions: [
                { name: 'all', label: 'All' },
                { name: 'aci', label: 'AutoCheck Insurance' },
                { name: 'aca', label: 'AutoCheck Auctions' },
                { name: 'vxc', label: 'VIN Cross Check' },
            ],
        };
    }

    async componentDidMount() {
        if (this.props.customers && this.props.customers.customers.length > 0) {
            await this.getCustomerData();
        } else {
            await this.props.actions.getCustomerItems(this.props.config);
            if (this.props.customers && this.props.customers.customers.length > 0) {
                await this.getCustomerData();
            }
        }
        // await this.props.actions.getCustomerGroups(this.props.config);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customers !== this.props.customers) {
            if (this.props.customers && this.props.customers.customers.length > 0) {
                this.getCustomerData();
            }
        }
    }

    getCustomerData = async () => {
        if (this.props.customers && this.props.customers.customers.length > 0) {
            this.props.actions.getCustomersData(this.props.config, this.props.customers.customers, this);
        }
    }

    reapplyTableOptions = () => {
        const tableOptions = getTableOptions(componentKey);
        if (!tableOptions) return;

        this.setState({ ...tableOptions });
        this.changeFilters(tableOptions.initialValues);
    };

    rowMapper = (row) => ({
        isActive: (row.isActive === undefined || row.isActive === null) ? true : row.isActive,
        isSuspended: (row.isSuspended === undefined || row.isSuspended === null) ? false : row.isSuspended,
        contactName: (row.contact && row.contact.contactName) ? row.contact.contactName : '',
        email: (row.contact && row.contact.emailAddress) ? row.contact.emailAddress : '',
        city: (row.billingAddress && row.billingAddress.city) ? row.billingAddress.city : '',
        state: (row.billingAddress && row.billingAddress.state) ? row.billingAddress.state : '',
        ...row,
    });

    getRowId = (row) => {
        return row.customerId;
    };

    changeCurrentPage = (currentPage) => {
        cacheTableOptions(componentKey, { currentPage });
        this.setState({ currentPage });
    };

    changePageSize = (pageSize) => {
        cacheTableOptions(componentKey, { pageSize });
        this.setState({ pageSize });
    };

    changeColumnOrder = (columnOrder) => {
        cacheTableOptions(componentKey, { columnOrder });
        this.setState({ columnOrder });
    };

    changeColumnWidths = (columnWidths) => {
        cacheTableOptions(componentKey, { columnWidths });
        this.setState({ columnWidths });
    };

    changeFilters = (filters) => {
        if (!filters) return;
        const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));

        const { searchBy, searchData, filterBy, filterByProduct } = filters;

        let filteredCustomers = this.state.allItems;
        if (filterByProduct) {
            filteredCustomers = filterCustomersByProduct(filterByProduct, this.state.allCustomers, localStorage.getItem('customerId'), isATSysAdmin);
            this.setState({ allItems: filteredCustomers });
        }

        let filteredRows = filteredCustomers.map(this.rowMapper);

        if (searchBy && searchData) {
            filteredRows = filteredRows
                .filter(customer =>
                    customer[searchBy] &&
                    customer[searchBy].toLowerCase().includes(searchData.toLowerCase())
                );
        }

        if (filterBy && filterBy !== 'all') {
            if (filterBy === 'active') {
                filteredRows = filteredRows.filter(customer => customer.isActive);
            } else if (filterBy === 'inactive') {
                filteredRows = filteredRows.filter(customer => !customer.isActive);
            } else if (filterBy === 'suspended') {
                filteredRows = filteredRows.filter(customer => customer.isSuspended);
            }
        }

        cacheTableOptions(componentKey, filters);
        this.setState({ rows: filteredRows });
    };

    changeSorting = (sorting) => {
        if (!sorting || !sorting.length) return;

        const sortBy = sorting[0].columnName;
        const sortDirection = sorting[0].direction;
        const sortedRows = [...this.state.rows]
            .sort((a, b) => compareCaseInsensitive(a[sortBy], b[sortBy], sortDirection));

        cacheTableOptions(componentKey, { sorting });
        this.setState({ rows: sortedRows, sorting });
    };

    cell = ({ column, style, tableRow, value }) => {
        const { row: { isActive, isSuspended, isSkeletonRow } } = tableRow;
        if (isSkeletonRow) {
            return <Table.Cell style={style}>{value}</Table.Cell>;
        }

        let content = <OverflowTip value={value}>{value}</OverflowTip>;

        if (column.name === 'menu') {
            content = this.renderMoreMenu(tableRow);
        } else if (column.name === 'isActive') {
            let className = 'active-';
            let title = '';
            let comp;

            if (!isActive) {
                className += '3';
                title = 'Inactive';
                comp = <InactiveIcon className={className} />;
            } else if (isSuspended) {
                className += '2';
                title = 'Suspended';
                comp = <SuspendedIcon className={className} />;
            } else {
                className += '1';
                title = 'Active';
                comp = <CheckIcon className={className} />;
            }

            content = (<Tooltip title={title} placement="left">
                {comp}
            </Tooltip>);
        }

        return <Table.Cell style={style}>{content}</Table.Cell>;
    };

    renderMoreMenu = (tableRow) => {
        const { row: { customerId, customerGroupId, isActive, isSuspended } } = tableRow;

        function renderVxcMenuItems() {
            return [
                (
                    <MenuItem
                        key="edit-portfolio"
                        component={Link}
                        to={`/edit-portfolio/${customerId}`}
                    >
                        Edit Portfolio
                    </MenuItem>
                ),
                (
                    <MenuItem
                        key="add-edit-portfolio-others"
                        component={Link}
                        to={`/add-edit-portfolio-others/${customerId}`}
                    >
                        Edit Other Settings
                    </MenuItem>
                ),
                (
                    <MenuItem
                        key="add-new-portfolio"
                        component={Link}
                        to={`/add-portfolio/${customerId}`}
                    >
                        Add New Portfolio
                    </MenuItem>
                )
            ];
        }

        function renderNonVxcMenuItems() {
            return [
                (
                    customerGroupId &&
                    <MenuItem
                        key="edit-customer-group"
                        component={Link}
                        to={`/add-edit-customer-group/${customerGroupId}`}
                    >
                        Edit Customer Group
                    </MenuItem>
                ),
                (
                    <MenuItem
                        key="view-locations-by-customer"
                        component={Link}
                        to={`/locations/customer/${customerId}`}
                    >
                        View Locations
                    </MenuItem>
                )
            ];
        }

        return (
            <SimpleMenu id={customerId}>
                <MenuItem
                    key="edit-customer"
                    component={Link}
                    to={`/add-edit-customer/${customerId}`}
                >
                    Customer Information
                </MenuItem>
                {
                    sessionStorage.getItem('product') === 'VIN Cross Check'
                        ? renderVxcMenuItems().map(mi => mi)
                        : renderNonVxcMenuItems().map(mi => mi)
                }
                <Divider />
                {/* <MenuItem
                        key="deactivate"
                        component={Link}
                        to={this.props.location.pathname}
                        onClick={() => this.handleToggleIsActive(customerId, isActive)}
                    >
                        {isActive ? 'Deactivate' : 'Activate'}
                    </MenuItem> */}
                <MenuItem
                    key="suspend"
                    component={Link}
                    to={this.props.location.pathname}
                    onClick={() => this.handleToggleIsSuspended(customerId, isSuspended)}
                >
                    {isSuspended ? 'Reinstate' : 'Suspend'}
                </MenuItem>
            </SimpleMenu>
        );
    };

    handleToggleIsActive = (id, isActive) => {
        const customer = this.state.allItems.find(cg => cg.customerId === id);

        customer.isActive = !isActive;

        this.props.actions.saveCustomer(customer, this.props.config, this);
    };

    handleToggleIsSuspended = (id, isSuspended) => {
        const customer = this.state.allItems.find(cg => cg.customerId === id);

        customer.isSuspended = !isSuspended;

        this.props.actions.saveCustomer(customer, this.props.config, this);
    };

    render() {
        const {
            addLink,
            columns,
            columnOrder,
            columnWidths,
            currentPage,
            filterByOptions,
            initialValues,
            loading,
            pageSize,
            pageSizes,
            rows,
            searchByOptions,
            sorting,
            tableColumnExtensions,
            title,
            productFilterOptions
        } = this.state;


        return (
            <Layout
                className="App"
                showMenu
                menuTitle=""
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                <Paper style={paperStyle}>
                    {loading && <LinearProgress className="linear-progress-top" />}
                    <Grid
                        rows={rows}
                        columns={columns}
                        getRowId={this.getRowId}
                    >
                        <TableFilters
                            addLink={addLink}
                            changeFilters={this.changeFilters}
                            filterByOptions={filterByOptions}
                            initialValues={initialValues}
                            searchByOptions={searchByOptions}
                            title={title}
                            productFilterOptions={this.props.person && isSysAdmin(this.props.person) ? productFilterOptions : []}
                        />

                        {filterByOptions && <IntegratedFiltering />}

                        <SortingState
                            sorting={sorting}
                            onSortingChange={this.changeSorting}
                        />

                        <PagingState
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />

                        <IntegratedSorting />

                        <IntegratedPaging />

                        <DragDropProvider />

                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={this.cell}
                        />

                        <TableColumnReordering
                            order={columnOrder}
                            onOrderChange={this.changeColumnOrder}
                        />

                        <TableColumnResizing
                            columnWidths={columnWidths}
                            onColumnWidthsChange={this.changeColumnWidths}
                        />

                        <TableHeaderRow
                            showSortingControls
                        />

                        <PagingPanel pageSizes={pageSizes} />
                    </Grid>
                </Paper>
            </Layout>
        );
    }
}

const reduxToProps = state => ({
    config: state.config.config,
    person: state.person.person,
    customers: state.customers.customers,
});

const dispatchToProps = dispatch => ({
    actions: {
        getCustomerItems: (config) => {
            dispatch(getCustomerGroups(config));
            dispatch(searchAllPages('person-locations', config))
            dispatch(searchAllPages('locations', config, true));
            dispatch(getCustomers(config));
            dispatch(searchAllPages('persons', config));
            dispatch(getReportTypes(config));

        },
        getCustomerGroups: (config) => {
            dispatch(getCustomerGroups(config));
        },
        getCustomersData: (config, customerItems, self) => {
            const product = ProductMap[sessionStorage.getItem('product')];
            const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));

            // dispatch(getCustomers(config)).then((result) => {
            let customers = customerItems;
            let rows = [];
            self.setState({ allCustomers: customers });

            if (self.props.location.pathname.includes('/location/')) {
                dispatch(searchAllPages('locations', config))
                    .then((locationsResult) => {
                        const { items: locations } = locationsResult.value.data;
                        const locationId = self.props.match.params.id;
                        const location = locations.find(l => l.locationId === locationId);

                        customers = customers.filter(c => c.primaryLocationId === locationId || c.customerId === location.customerId);

                        customers = filterCustomersByProduct(product, customers, localStorage.getItem('customerId'), isATSysAdmin);
                        rows = customers.map(self.rowMapper);

                        self.setState({ loading: false, allItems: customers, rows }, () => {
                            self.reapplyTableOptions();
                        });
                    });
            } else if (self.props.location.pathname.includes('/customer-group/')) {
                const customerGroupId = self.props.match.params.id;

                customers = customers.filter(c => c.customerGroupId === customerGroupId);
                rows = customers.map(self.rowMapper);

                self.setState({ loading: false, allItems: customers, rows }, () => {
                    self.reapplyTableOptions();
                });
            } else {
                customers = filterCustomersByProduct(product, customers, localStorage.getItem('customerId'), isATSysAdmin);

                rows = customers.map(self.rowMapper);

                self.setState({ loading: false, allItems: customers, rows }, () => {
                    self.reapplyTableOptions();
                });
            }
            // });
        },
        saveCustomer: (customer, config, self) => {
            self.setState({ loading: true });

            dispatch(addEditCustomer(customer, config)).then(() => {
                dispatch(getCustomers(config));
            });
        },
    }
});

const ConnectedComponent = connect(reduxToProps, dispatchToProps)(CustomerList);

export default (reduxForm({ form: 'CustomerList' })(ConnectedComponent));


// WEBPACK FOOTER //
// ./src/components/Customer/Customer/CustomerList.js